import { Component } from '@angular/core';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { ConnectionService } from 'src/app/services/connection.service';
import { NgClass, NgIf } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrl: './settings.component.scss',
    imports: [
        NgClass,
        RouterLink,
        RouterLinkActive,
        NgIf,
        MatIcon,
        RouterOutlet,
    ],
})
export class SettingsComponent {
    constructor(public breakpoint: BreakpointService, public connection: ConnectionService) { }
}
